import { Component, ChangeDetectionStrategy, inject, OnInit, DOCUMENT, ChangeDetectorRef } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { SeoService } from '../../../Services/SeoService';
import { LocalizationService } from '../../../Services/localization-service';

@Component({
  selector: 'app-support',
  imports: [TranslatePipe],
  templateUrl: './support.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './support.scss'
})
export class Support implements OnInit {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly seoService = inject(SeoService);
  private readonly localizationService = inject(LocalizationService);
  private readonly document = inject(DOCUMENT);


  ngOnInit(): void {
    this.localizationService.getLanguage().subscribe(lang => {
      if (lang != '') {
        const canonicalUrl = `${this.document.location.origin}/${lang}/support`;
        this.seoService.updateCanonicalUrl(canonicalUrl);
        this.cdr.detectChanges();
      }
    });
  }
}
